import { Select } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const TableBodyWrapper = styled.div`
  > div {
    overflow-x: unset;
  }
`

export const TableWrapper = styled.div`
  overflow-x: auto;
  max-height: 70vh;
  width: 100%;
  overflow-y: auto;
  box-shadow: ${({ theme }) => theme.shadow['02']};

  table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid ${({ theme }) => theme.color.border.default};
    border-radius: 5px;

    tr:nth-child(even) {
      background-color: ${({ theme }) => theme.color.background.highlight};
    }

    tr:hover {
      background-color: ${({ theme }) => theme.color.background.hover};
    }

    td,
    th {
      border: 1px solid ${({ theme }) => theme.color.border.default};
      padding: 8px;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`

export const XLSViewerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['04']};
`

export const StyledSelect = styled(Select)`
  &.lds-ant-select {
    width: fit-content;
  }
`
